import { onChange$ } from '@nx-paeonia/utils-events';

export function changeTemplateHandler() {
  onChange$('[data-template][data-template-action="add"]', (_, element: HTMLElement) => {
    const templateId = element.dataset['template'];
    if (!templateId) return;
    const template = document.querySelector<HTMLTemplateElement>(templateId);
    if (!template) return;
    const clone = template.content.cloneNode(true);
    element.insertAdjacentElement('afterend', clone as HTMLElement);
  });

  onChange$('[data-template][data-template-action="remove"]', (_, element: HTMLElement) => {
    const templateId = element.dataset['template'];
    if (!templateId) return;
    const template = document.querySelector<HTMLElement>(templateId);
    if (!template) return;
    template.remove();
  });
}
